//START GENAI@CHATGPT4
//eslint-disable-next-line
export const addMissingProperties = (target: any, source: any) => {
  Object.keys(source).forEach(key => {
    target[key] = target[key] ?? source[key];
  });
};

//START GENAI@CHATGPT4
//eslint-disable-next-line
export const removeUndefinedProperties = (obj: any) => {
  //eslint-disable-next-line
  Object.keys(obj).forEach(key => (obj[key] === undefined ? delete obj[key] : {}));
};
//END GENAI@CHATGPT4
//END GENAI@CHATGPT4
